<app-purchase-credit-note-grid
    #purchaseCreditNoteGridComponent
    [permissionKey]="'purchaseCreditNotes.list'"
    [filter]="['ThirdId.Id eq ' + element.Id]"
    (add)="onAddButtonClicked()"
    [columns]="PurchaseCreditNoteColumns"
></app-purchase-credit-note-grid>